import { useEffect } from 'react'
import { isMeinBuero } from '@/utils/build-env'

const isMB = isMeinBuero()

/**
 * Custom hook to temporarily elevate the HubSpot chat z-index above other elements.
 * Useful for components like modals, overlays, or onboarding flows where
 * the chat widget should still be visible
 * IMPORTANT: Currently only used for mb.
 */
export const useElevateHubSpotChat = () => {
  if (!isMB) { return }

  useEffect(() => {
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container')
    if (hubspotChat) {
      hubspotChat.classList.add('high-z-index')
    }

    // Cleanup function to reset z-index when component unmounts
    return () => {
      const hubspotChat = document.getElementById('hubspot-messages-iframe-container')
      if (hubspotChat) {
        hubspotChat.classList.remove('high-z-index')
      }
    }
  }, [])
}
